import {createLayout} from '../util/struct_array';

export default createLayout([
    {name: 'a_pos', type: 'Int16', components: 2},
    {name: 'a_texture_pos', type: 'Uint16', components: 2}
]);
